import React, { Dispatch, SetStateAction } from 'react';
import { Box, Stack } from '@mui/material';

import { CalendarView } from '../types';
import { CalendarViews } from './CalendarViews';
import { CalendarActions } from './CalendarActions';
import { CalendarUserSelect } from './CalendarUserSelect';

interface Props {
  view: CalendarView;
  setView: Dispatch<SetStateAction<CalendarView>>;
  showUserSelect: boolean;
  userProfileId: string | null;
  onUserProfileChange: (userProfileId: string | null) => void;
}

export const CalendarPanel = ({ view, setView, showUserSelect, userProfileId, onUserProfileChange }: Props) => {
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: '20% 1fr', gap: '1rem' }}>
      <CalendarViews view={view} setView={setView} />

      <Stack direction="row" justifyContent="flex-end" alignItems="center" gap="1rem">
        {showUserSelect && <CalendarUserSelect userProfileId={userProfileId} onChange={onUserProfileChange} />}

        <CalendarActions />
      </Stack>
    </Box>
  );
};
